import { Flex,Modal } from "antd";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import "../../../../config/styles/theme.less";
import { formatTranslation } from "../../../../shared/utils/translationUtils";
import "../../styles.less";

interface ZoneInfoModalProps {
  isModalOpen: boolean;
  handleModalClose: () => void;
}

const ZoneInfoModal: FC<ZoneInfoModalProps> = ({
  isModalOpen,
  handleModalClose,
}) => {
  const { t } = useTranslation();

  return (
    <div className="autozones-info-modal" data-testid="zone-info-modal">
      <Modal
        title={formatTranslation(t("zoneInfoModal.basicModalTitle"))}
        open={isModalOpen}
        onCancel={handleModalClose}
        footer={null}
        width={424}
      >
        <p>{formatTranslation(t("zoneInfoModal.successDescription"))}</p>
        <br />

        <strong>
          {formatTranslation(t("zoneInfoModal.heterogeneityIndex"))}
        </strong>
        <p>{formatTranslation(t("zoneInfoModal.heterogeneityDescription"))}</p>
        <br />
        <strong>
          {formatTranslation(t("zoneInfoModal.consistencyIndex"))}
        </strong>
        <p>{formatTranslation(t("zoneInfoModal.consistencyDescription"))}</p>
        <br />

        <strong>
          {formatTranslation(t("zoneInfoModal.variabilityIndex"))}
        </strong>
        <p>{formatTranslation(t("zoneInfoModal.variabilityDescription"))}</p>
        <br />

        <p>{formatTranslation(t("zoneInfoModal.scaleDescription"))}</p>
        <Flex justify="space-between" className="color-scale">
          <span>{formatTranslation(t("zoneInfoModal.lowIndex"))}</span>
          <span>{formatTranslation(t("zoneInfoModal.highIndex"))}</span>
        </Flex>
        <div className="color-scale">
          <div className="scale-low"></div>
          <div className="scale-medium"></div>
          <div className="scale-high "></div>
        </div>
        <Flex justify="space-between" className="text-semibold text-sm">
          <span className="">0</span>
          <Flex vertical={false} gap={4}>
            <span>0.6</span> <span>0.65</span>
          </Flex>
          <span className="">1</span>
        </Flex>
      </Modal>
    </div>
  );
};

export default ZoneInfoModal;
